import {useNavigate} from 'react-router-dom'
import {useOktaStorage} from '@/hooks/useOktaStorage'
import {AvatarButton} from '@/components/atoms'
import {ROUTES} from '@/utils/constants/routesConstants'

/**
 * A button component that displays a user avatar with the user's name and handles navigation on click
 * @param {Object} props - The component props
 * @returns {JSX.Element} UserAvatarButton component
 */
export function UserAvatarButton() {
  const {
    claims: {FirstName, LastName},
  } = useOktaStorage()
  const navigate = useNavigate()

  const fullName = !!FirstName && !!LastName ? `${FirstName} ${LastName}` : ''

  return <AvatarButton showArrowIcon={true} name={fullName} onClick={() => navigate(ROUTES.LOGOUT)} testId="header-user-avatar" />
}
